export const debounce = (fn: () => void, ms: number): (() => void) => {
  let timer: number | NodeJS.Timeout | null = null;
  return (): void => {
    if (timer !== null) {
      /*
        This doesn't actually have any effect on the code, but we do it because TS doesn't
        seem to treat overloaded functions defined in different modules as actual overloads
        so it won't accept a union type of number and NodeJS.Timeout.
      */
      clearTimeout(timer as number);
    }

    timer = setTimeout(() => {
      timer = null;
      fn.apply(this, []);
    }, ms);
  };
};
